<template>
  <v-container fluid class="paymethod-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs
          color="primary"
        >
          <v-tabs-slider></v-tabs-slider>

          <v-tab
            :href="`#tab-account`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-heart-box</v-icon>
            Pay Method
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-photo`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            Photo
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-qrcode`"
          >
            <v-icon class="mr-3">mdi-camera</v-icon>
            QR Code
          </v-tab>
          <v-tab></v-tab>
          <v-tab></v-tab>
          <v-tab-item
            :value="'tab-account'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Pay Method</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePayMethod($event, 'paymethodcode')"
                        v-bind:value="initvalue.paymethodcode"
                        placeholder="Pay Method Code"
                        persistent-hint
                        single-line hint="Enter the pay method code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePayMethod($event, 'paymethodname')"
                        v-bind:value="initvalue.paymethodname"
                        placeholder="Pay Method Name"
                        persistent-hint
                        single-line hint="Enter the pay method name">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=paymethodtypes
                        :value="initvalue.paymethodtype"
                        outlined
                        dense
                        v-on:change="onChangePayMethod($event, 'paymethodtype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the pay method type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="['USD', 'SGD', 'KHR', 'MMK', 'THB']"
                        :value="initvalue.paymethodcurrency"
                        outlined
                        dense
                        v-on:change="onChangePayMethod($event, 'paymethodcurrency')"
                        placeholder="Currency"
                        persistent-hint
                        single-line hint="Please choose the currency">
                      </v-select>
                      <v-text-field
                        type="number"
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePayMethod($event, 'paymethoddiscount')"
                        v-bind:value="initvalue.paymethoddiscount"
                        placeholder="Pay Method Discount"
                        persistent-hint
                        single-line hint="Enter the pay method discount">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePayMethod($event, 'paymethodlink')"
                        v-bind:value="initvalue.paymethodlink"
                        placeholder="Pay Method Link"
                        persistent-hint
                        single-line hint="Enter the pay method link">
                      </v-text-field>
                      <v-textarea
                        v-on:change="onChangePayMethod($event, 'paymethodinfo')"
                        v-bind:value="initvalue.paymethodinfo"
                        outlined
                        rows="3"
                        label="Pay Method Info"
                        hint="please enter the pay method info"
                      ></v-textarea>
                      <v-textarea
                        v-on:change="onChangePayMethod($event, 'paymethoddata')"
                        v-bind:value="initvalue.paymethoddata"
                        outlined
                        rows="3"
                        label="Data"
                        hint="please enter the data"
                      ></v-textarea>
                      <v-switch
                          color="primary"
                          v-on:change="onChangePayMethod($event, 'paymethodstatus')"
                          v-bind:label="initvalue.paymethodstatus"
                          v-model="initvalue.paymethodstatus"
                          value="Active"
                      ></v-switch>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="7">
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/paymethod/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPayMethod()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-photo'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload Photo</p>
                        <v-file-input label="File input" v-on:change="onChangePhoto" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/paymethod/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPhoto()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item
              :value="'tab-qrcode'"
          >
            <v-card
                flat
                tile
            >
              <v-card-text>

                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Upload QR Code</p>
                        <v-file-input label="File input" v-on:change="onChangeQr" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl2" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/paymethod/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editQrcode()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import router from '@/Routes';
import {mapActions, mapState} from "vuex";

export default {
  data () {
    return {
      paymethod: {},
      photo: {},
      qrcode: {},
      initvalue: {},
      imageurl: undefined,
      imageurl2: undefined,
      paymethodtypes: ['Cash', 'Credit Card', 'Qr Code'],
    }
  },
  methods: {
    ...mapActions('PayMethod', ['updatePayMethodRequest','updatePayMethodImageRequest','updatePayMethodQrRequest','getPayMethodsRequest']),
    async editPayMethod() {
      this.paymethod._id = this.initvalue._id;
      await this.updatePayMethodRequest(this.paymethod);
      router.push('/paymethod/list');
    },
    async editPhoto() {
      this.photo._id = this.initvalue._id;
      await this.updatePayMethodImageRequest(this.photo);
      router.push('/paymethod/list');
    },
    async editQrcode() {
      this.qrcode._id = this.initvalue._id;
      await this.updatePayMethodQrRequest(this.qrcode);
      router.push('/paymethod/list');
    },
    onChangePayMethod(value, field){
      this.paymethod[field] = value;
    },
    onChangePhoto(file) {
      if (!file) {return;}
      this.photo.imagfile = file;
      this.photo.imagename = file.name;
      this.renderImage(file, 1);
    },
    onChangeQr(file) {
      if (!file) {return;}
      this.qrcode.imagefile = file;
      this.qrcode.imagename = file.name;
      this.renderImage(file, 2);
    },
    renderImage(file, route) {
      const reader = new FileReader();
      reader.onload = e => {
        if(route==2) this.imageurl2 = e.target.result;
        else this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  },
  computed: {
    ...mapState('PayMethod', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'PayMethodList' });
    this.imageurl = this.initvalue.paymethodimage;
    this.imageurl2 = this.initvalue.qrcodeimage;
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
